import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SwitchInput from '../../../../../libraries/utils/components/switch-input';
import { AnalyticsProvider } from '../../../../../scripts/services/analytics-provider';
class StrictExternalUrl extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { status: this.props.status };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.status !== this.props.status) {
      this.setState({ status: nextProps.status });
    }
  }

  toolTipText =
    'Recognizes any link format, (implicit links  will be flagged as external links) \n i.e. website.com will be caught in the \n same way as http://www.website.com';

  onChange = value => {
    AnalyticsProvider.track(`url strict mode toggled ${value}`);
    this.setState({ status: value });
    this.props.onStatusChange(value);
  };

  render() {
    return (
      <div className="strict-external-url-wrapper">
        <SwitchInput value={this.state.status} onChange={this.onChange} />
        <div className="strict-label">Strict detection of external links</div>
        <div
          aria-label={this.toolTipText}
          data-balloon-pos="up"
          className="info-svg"
          data-balloon-length="large"
        >
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="info-circle"
            className="svg-inline--fa fa-info-circle fa-w-16 info-svg"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path
              fill="#C3C4C7"
              d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
            />
          </svg>
        </div>
      </div>
    );
  }
}

StrictExternalUrl.propTypes = {
  status: PropTypes.bool.isRequired,
  onStatusChange: PropTypes.func.isRequired
};

export default StrictExternalUrl;
